import { render } from "./LanguageSwitcher.vue?vue&type=template&id=c1ecf24c&scoped=true&bindings={\"setLocale\":\"options\"}"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=c1ecf24c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1ecf24c"

export default script